import { styled } from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';

export const PageContainer = styled(Column)`
  max-width: 600px;
  margin: 0 auto;
  padding: 40px 20px;
  flex-grow: 1;
  min-height: 100vh;
  background-color: #ffffff;
`;

export const FormContainer = styled(Column)`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const ButtonWrapper = styled.div`
  flex: 1;
`;

export const ErrorContainer = styled(Column)`
  margin-top: 15px;
  padding: 10px;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
`;

export const SuccessContainer = styled(Column)`
  margin-top: 15px;
  padding: 10px;
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 4px;
`;

export const Container = styled(Column)`
  max-width: 600px;
  margin: 0 auto;
  padding: 40px 20px;
  flex-grow: 1;
`;

export const ButtonContainer = styled(Row)`
  margin-top: 40px;
  display: flex;
  flex-flow: row nowrap;
  gap: 10px;
  justify-content: end;

  & > button {
    display: block;
    max-width: 160px;
  }
  & > button:last-of-type {
    position: relative;
    top: -1px;
  }
`;
